import { useQueryDataDebug } from './hooks/use-query-data-debug'
import { useBoxModal } from './use-box-modal'

/**
 * @see {@link useQueryDataDebug} to change the query data.
 */
export function useBoxModalDebug(...params: Parameters<typeof useBoxModal>) {
  const [props] = params
  useQueryDataDebug(props)
  return useBoxModal(...params)
}

useBoxModalDebug.fragments = useBoxModal.fragments
